import axios from "axios";
import { config } from "../../Network_Calls/config";

const getOrganizationUser = async () => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL + `/customer/imp/${localStorage.getItem("origin")}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    if (error.response.status=== 401){
      localStorage.clear()
      window.location.href = '/login';
    }
    console.log(error);
  }
};

const getImplCustomers = async (impl,type) => {
  // console.log(type,"CHECKTHISONE")
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/customer/all",
    {
      impl_name: impl,
      journey_type:type
    },
    {
      ...config(),
    }
  );
  return response;
};

const saveInteraction = async (payload) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
      "/interactions/saveInteraction",

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const getInteractions = async (payload) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL + "/interactions/getInteractions",

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const getCustomer = async (impl_id, id, journey_type) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/info/" + id,
      {
        implementation_id: impl_id,
        journey_type:journey_type
      },
      {
        ...config(),
      }
    );

    console.log("response for customer ", response);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const get_event_attributes = async (source_id, impl_id) => {
  try {
    console.log("req body", source_id, impl_id)
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/event_attribute",
      {
        sourceId:source_id,
        implId: impl_id
      },
      {
        ...config(),
      }
    );

    console.log("response for get event attribute", response);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const postTag = async (
  impl_id,
  tag,
  journeyType,
  description,
  dueDate,
  owner,
  contributors,
color_type
) => {
  //console.log("in post net", color_type)
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tags/",
      {
        impl_id,
        tag,
        journeyType,
        description,
        dueDate,
        owner,
        contributors,
        color_type ,
      },
      {
        ...config(),
      }
    );
    //console.log("ssssressss", response)
    return response;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};

const getImplTags = async (impl_id, journey_type) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/alltags/",
      {
        impl_id,
        journey_type,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};

const postTagData = async (tagData, tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tag/data/",
      {
        tagData,
        tag_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const getTagData = async (tag_id,color_type) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tagData/edit/",
      {
        tag_id,
        color_type
      },
      {
        ...config(),
      }
    );
    //console.log("response from get tag data", response)
    return response;
  } catch (error) {
    console.log(error);
  }
};

const deleteTag = async (tag_id) => {
  try {
    const response = await axios.delete(
      process.env.REACT_APP_SERVER_URL + `/customer/tagData/${tag_id}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
const editTagData=async (cusId,tag_id) => {
  console.log("Edit Tag ID",cusId )
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + `/customer/tagData/editData/`,
      {
        cusId,
        tag_id
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const lastRefreshDate = async(impl_id) =>{
  try {
    //console.log("hshshshhsssss from lastrefresh", impl_id)
    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL + `/customer/last-refresh-date?impl_id=${impl_id}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

const fetchTagDataOnDate = async (id, tag) => {
  //console.log("from network call tag dat afectch", id, tag)
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + '/customer/fetchTagDataOnDate',
      {
        id: id,
        tag: tag
      },
      {
        ...config(),
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error; 
  }
};


const getDossierActionPlanCount = async(cutomerIdArray) =>{

  //console.log("Sssssssssssssssssssssssssssss", cutomerIdArray)
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + `/dossier/getDossierActionPlanCount`,
      {
        cutomerIdsArray: cutomerIdArray,
      },
      {
        ...config(),
      }
    );
    //console.log("respsoosossss for action plan ", response);
    return response;
  } catch (error) {
    console.log(error);
  }
} 


const getTopViewedLink = async (id, journey_type) => {
  //console.log("from network calltopppppppppp", id)
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + '/customer/getTopViewedLink',
      {
        impl_id: id, 
        journeyType:journey_type
      },
      {
        ...config(),
      }
    );

    //console.log("top viewed link", response)
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error; 
  }
};


const getRecentlyAddedLink = async (id, journey_type) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + '/customer/getRecentlyAddedLink',
      {
        impl_id: id,
        journeyType:journey_type
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error; 
  }
};


const donutChartUserInfoFetch = async (id,journey_type) => {

  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + '/customer/donutChartUserInfoFetch',
      {
        impl_id: id,
        journeyType:journey_type
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error; 
  }
};

const updateInteraction = async (
  payload
) => {

  const response =
    await axios.put(

      process.env.REACT_APP_SERVER_URL +
      `/interactions/updateInteraction/${payload.interaction_id}`,

      payload,

      {
        ...config(),
      }
    );

  return response;
};

const deleteInteraction = async (
  interactionId
) => {

  const response = await axios.delete(

    process.env.REACT_APP_SERVER_URL + `/interactions/deleteInteraction/${interactionId}`,

    {
      ...config(),
    }
  );

  return response;
};

const getStages = async (
  impl_id
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL + `/customer/stages`,

    {
      impl_id: impl_id,
    },

    {
      ...config(),
    }
  );

  return response.data;
};

const getStatus = async (
  impl_id
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL + `/customer/int-status`,

    {
      impl_id,
    },

    {
      ...config(),
    }
  );

  return response.data;
};

const createContact = async (
  payload
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
    `/interactions/createContact`,

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const searchDropdownData = async (
  payload
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
    `/interactions/searchDropdownData`,

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const searchMentionUsers = async (
  keyword
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
    `/interactions/userSearch`,

    {
      keyword,
    },

    {
      ...config(),
    }
  );

  return response;
};


export {
  getOrganizationUser,
  getImplCustomers,
  getCustomer,
  postTag,
  getImplTags,
  postTagData,
  getTagData,
  deleteTag,
  editTagData,
  lastRefreshDate,
  fetchTagDataOnDate,
  getDossierActionPlanCount,
  getTopViewedLink,
  getRecentlyAddedLink,
  donutChartUserInfoFetch,
  get_event_attributes,
  saveInteraction,
  getInteractions,
  updateInteraction,
  deleteInteraction,
  getStages,
  getStatus,
  createContact,
  searchDropdownData,
  searchMentionUsers,
};

